import React, {Component} from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import {NavLink} from 'react-router-dom';
import Navigation from '../Navigation/Navigation';
import Popper from "@material-ui/core/Popper/Popper";
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Fade from "@material-ui/core/Fade/Fade";
import ContentPanel from "../ContentPanel/ContentPanel";
import Skeleton from "../Skeleton/Skeleton";
import Overlay from "../Overlay/Overlay";

class Header extends Component {

    wasTriggeredForDesktopFlag = false;
    wasTriggeredForMobileFlag = false;

    rapidRewardsEnrollmentUrl = global.config.rapidRewardsEnrollmentUrl;

    rapidRewardsLoginUrl = global.config.rapidRewardsLoginUrl;

    rapidRewardsFAQUrl = global.config.rapidRewardsFAQUrl;

    constructor(props) {
        super(props);

        this.state = {
            currentPopper: null,
            isOverlayShown: false,
            isMobileNavOpen: false,
            searchValue: ""
        };

        this.toolBarNavigationAnchorElement = React.createRef()
    }

    componentDidMount() {
        this.handleNavAppearanceBasedOnScreenSize();
        window.addEventListener('resize', this.handleNavAppearanceBasedOnScreenSize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleNavAppearanceBasedOnScreenSize);
    }

    handleNavAppearanceBasedOnScreenSize = () => {
        if (document.documentElement.clientWidth > 1024 && !this.wasTriggeredForDesktopFlag) {
            this.setState({
                isMobileNavOpen: false
            });
            this.wasTriggeredForDesktopFlag = true;
            this.wasTriggeredForMobileFlag = false;
        }

        if (document.documentElement.clientWidth < 1024 && !this.wasTriggeredForMobileFlag) {
            this.wasTriggeredForMobileFlag = true;
            this.wasTriggeredForDesktopFlag = false;
        }
    };

    mobileNavHandler = () => {
        this.setState({
            isMobileNavOpen: !this.state.isMobileNavOpen
        })
    };

    handleDesktopNavClick = (event) => {
        this.setState({
            isOverlayShown: true,
            currentPopper: event.currentTarget.id,
        });
    };

    handlePopperClose = () => {
        this.setState({
            isOverlayShown: false,
            currentPopper: null,
        });
    };

    handleDesktopNavClickAway = () => {
        this.setState({
            isOverlayShown: false,
            currentPopper: null
        })
    };

    handleMobileNavClickAway = (event) => {
        if (this.state.isMobileNavOpen) {
            const clickedElement = event.target;
            const clickedElementIsHamburgerMenu =
                    clickedElement.getAttribute('id') === 'hamburger-menu' ||
                    clickedElement.parentElement.getAttribute('id') === 'hamburger-menu' ||
                    clickedElement.parentElement.parentElement.getAttribute('id') === 'hamburger-menu';

            if (!(this.state.isMobileNavOpen && clickedElementIsHamburgerMenu)) {
                this.setState({
                    isMobileNavOpen: false
                })
            }
        }
    };

    handleMobileNavLinkClick = () => {
        this.setState({
            isMobileNavOpen: false
        })
    };

    handleSearch = (value) => {
        this.setState({
            searchValue: value
        });
    }

    render() {
        return (
            <AppBar position="static" className="header">
                <div className="header__top-bar">
                    <div className="wrapper">
                        <ul className="unstyled-list top-bar">
                            <li className="top-bar__item">
                                <NavLink to="/contact" className="top-bar__link">
                                    Contact
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
                <Toolbar className="header__toolbar">
                    <div className="wrapper wrapper--toolbar">
                        <IconButton id="hamburger-menu" className="header__menu" disableRipple={true} color="inherit" aria-label="Menu" onClick={this.mobileNavHandler}>
                            <MenuIcon />
                        </IconButton>
                        <NavLink to="/" className="header__logo-wrapper">
                            <img className="header__logo" src="./assets/Southwest_cargo_online_rgb_white.svg" alt="" />
                        </NavLink>
                        <nav ref={this.toolBarNavigationAnchorElement} className="header-toolbar-navigation">
                            <div className="header-toolbar-navigation__links">
                                <Button id="ship" className="header-toolbar-navigation__link" disableRipple={true} onClick={this.handleDesktopNavClick} color="inherit">
                                    Ship
                                </Button>
                                <Popper
                                    className="header-toolbar-popper"
                                    open={this.state.currentPopper === "ship"}
                                    anchorEl={this.toolBarNavigationAnchorElement.current}
                                    onClose={this.handlePopperClose}
                                    placement={"bottom-end"}
                                >
                                    <ClickAwayListener onClickAway={this.handleDesktopNavClickAway}>
                                        <Fade timeout={300} in={this.state.currentPopper === "ship"} id="menu-list">
                                            <div className="header-popper header-popper--ship">
                                                <div className="header-popper__nav">
                                                    <div className="header-popper__title-container">
                                                        <img src="./assets/icons/shipping.svg" alt="Ship" style={{ height: "48px", width: "48px" }} />
                                                        <NavLink to="/ship/" onClick={this.handlePopperClose} className="header-popper__title">
                                                            Ship
                                                        </NavLink>
                                                    </div>
                                                    <div className="header-popper__lists-container">
                                                        <ul className="unstyled-list header-popper__list">
                                                            <li className="header-popper__item">
                                                                <NavLink onClick={this.handlePopperClose} to="/ship/products" className="header-popper__link">
                                                                    Products
                                                                </NavLink>
                                                            </li>
                                                            <li className="header-popper__item">
                                                                <NavLink onClick={this.handlePopperClose} to="/ship/rates" className="header-popper__link">
                                                                    Rates
                                                                </NavLink>
                                                            </li>
                                                            <li className="header-popper__item">
                                                                <NavLink onClick={this.handlePopperClose} to="/ship/guidelines-and-tools" className="header-popper__link">
                                                                    Guidelines & Tools
                                                                </NavLink>
                                                            </li>
                                                            <li className="header-popper__item">
                                                                <NavLink onClick={this.handlePopperClose} to="/ship/facilities" className="header-popper__link">
                                                                    Facilities
                                                                </NavLink>
                                                            </li>
                                                        </ul>
                                                        <ul className="unstyled-list header-popper__list">
                                                            <li className="header-popper__item">
                                                                <NavLink onClick={this.handlePopperClose} to="/ship/flight-schedules" className="header-popper__link">
                                                                    Flight Schedules
                                                                </NavLink>
                                                            </li>
                                                            <li className="header-popper__item">
                                                                <NavLink onClick={this.handlePopperClose} to="/ship/charges-and-payments" className="header-popper__link">
                                                                    Charges & Payments
                                                                </NavLink>
                                                            </li>
                                                            <li className="header-popper__item">
                                                                <NavLink onClick={this.handlePopperClose} to="/ship/book" className="header-popper__link">
                                                                    Book
                                                                </NavLink>
                                                            </li>
                                                            <li className="header-popper__item">
                                                                <NavLink onClick={this.handlePopperClose} to="/learn/how-to-ship" className="header-popper__link">
                                                                    How to Ship
                                                                </NavLink>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="header-popper__marketing-container">
                                                    <ContentPanel
                                                        skeleton={<Skeleton type="DESKTOP_NAVIGATION_PANEL" />}
                                                        errorTemplate={<Skeleton type="DESKTOP_NAVIGATION_PANEL_ERROR" />}
                                                        templateUrl="./content/navigation/page-components/text-block/ship-ad.html"
                                                    />
                                                </div>
                                                <button className="header-popper__close" onClick={this.handlePopperClose}>
                                                    <img src="./assets/icons/close.svg" alt="" />
                                                </button>
                                            </div>
                                        </Fade>
                                    </ClickAwayListener>
                                </Popper>

                                <Button id="manage" className="header-toolbar-navigation__link" disableRipple={true} onClick={this.handleDesktopNavClick} color="inherit">
                                    Manage
                                </Button>
                                <Popper
                                    className="header-toolbar-popper"
                                    open={this.state.currentPopper === "manage"}
                                    anchorEl={this.toolBarNavigationAnchorElement.current}
                                    onClose={this.handlePopperClose}
                                    placement={"bottom-end"}
                                >
                                    <ClickAwayListener onClickAway={this.handleDesktopNavClickAway}>
                                        <Fade timeout={300} in={this.state.currentPopper === "manage"} id="menu-list">
                                            <div className="header-popper header-popper--manage">
                                                <div className="header-popper__nav">
                                                    <div className="header-popper__title-container">
                                                        <img src="./assets/icons/list.svg" alt="Manage" style={{ height: "42px", width: "42px" }} />
                                                        <NavLink to="/manage/" onClick={this.handlePopperClose} className="header-popper__title">
                                                            Manage
                                                        </NavLink>
                                                    </div>
                                                    <div className="header-popper__lists-container">
                                                        <ul className="unstyled-list header-popper__list">
                                                            <li className="header-popper__item">
                                                                <NavLink onClick={this.handlePopperClose} to="/manage/tracking" className="header-popper__link">
                                                                    Track your shipment
                                                                </NavLink>
                                                            </li>
                                                            <li className="header-popper__item">
                                                                <a
                                                                    href="https://www.southwest.com/air/flight-status/index.html?REF=SWACARGO"
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="external-link header-popper__link"
                                                                >
                                                                    Flight Status
                                                                </a>
                                                            </li>
                                                            <li className="header-popper__item">
                                                                <NavLink onClick={this.handlePopperClose} to="/manage/file-a-claim" className="header-popper__link">
                                                                    File a Claim
                                                                </NavLink>
                                                            </li>
                                                            <li className="header-popper__item">
                                                                <NavLink onClick={this.handlePopperClose} to="/manage/forms-and-applications" className="header-popper__link">
                                                                    Forms & Applications
                                                                </NavLink>
                                                            </li>
                                                            <li className="header-popper__item">
                                                                <NavLink
                                                                    onClick={this.handlePopperClose}
                                                                    to="/manage/forms-and-applications/email-preference-form/"
                                                                    className="header-popper__link"
                                                                >
                                                                    Manage Email Preference
                                                                </NavLink>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="header-popper__marketing-container">
                                                    <ContentPanel
                                                        skeleton={<Skeleton type="DESKTOP_NAVIGATION_PANEL" />}
                                                        errorTemplate={<Skeleton type="DESKTOP_NAVIGATION_PANEL_ERROR" />}
                                                        templateUrl="./content/navigation/page-components/text-block/manage-ad.html"
                                                    />
                                                </div>
                                                <button className="header-popper__close" onClick={this.handlePopperClose}>
                                                    <img src="./assets/icons/close.svg" alt="" />
                                                </button>
                                            </div>
                                        </Fade>
                                    </ClickAwayListener>
                                </Popper>

                                <Button id="rapidRewards" className="header-toolbar-navigation__link" disableRipple={true}
                                        href={this.rapidRewardsFAQUrl} target="_blank" color="inherit"><span>Rapid Rewards<sup>®</sup> Cargo</span></Button>
                                <Button id="learn" className="header-toolbar-navigation__link" disableRipple={true} onClick={this.handleDesktopNavClick} color="inherit">
                                    Learn
                                </Button>
                                <Popper
                                    className="header-toolbar-popper"
                                    open={this.state.currentPopper === "learn"}
                                    anchorEl={this.toolBarNavigationAnchorElement.current}
                                    onClose={this.handlePopperClose}
                                    placement={"bottom-end"}
                                >
                                    <ClickAwayListener onClickAway={this.handleDesktopNavClickAway}>
                                        <Fade timeout={300} in={this.state.currentPopper === "learn"} id="menu-list">
                                            <div className="header-popper header-popper--learn">
                                                <div className="header-popper__nav">
                                                    <div className="header-popper__title-container">
                                                        <img src="./assets/icons/lightbulb.svg" alt="Learn" style={{ height: "48px", width: "48px" }} />
                                                        <NavLink to="/learn/" onClick={this.handlePopperClose} className="header-popper__title">
                                                            Learn
                                                        </NavLink>
                                                    </div>
                                                    <div className="header-popper__lists-container">
                                                        <ul className="unstyled-list header-popper__list">
                                                            <li className="header-popper__item">
                                                                <NavLink onClick={this.handlePopperClose} to="/learn/how-to-ship" className="header-popper__link">
                                                                    How to Ship
                                                                </NavLink>
                                                            </li>
                                                            <li className="header-popper__item">
                                                                <NavLink onClick={this.handlePopperClose} to="/learn/specialty-shipments" className="header-popper__link">
                                                                    Specialty Shipments
                                                                </NavLink>
                                                            </li>
                                                            <li className="header-popper__item">
                                                                <NavLink onClick={this.handlePopperClose} to="/learn/faq" className="header-popper__link">
                                                                    FAQ
                                                                </NavLink>
                                                            </li>
                                                            <li className="header-popper__item">
                                                                <a href="https://ship.swacargo.com/LithiumBatteryGuidelines" className="header-popper__link">
                                                                    Lithium Battery Guidelines
                                                                </a>
                                                            </li>
                                                            <li className="header-popper__item">
                                                                <NavLink onClick={this.handlePopperClose} to="/learn/declared-value" className="header-popper__link">
                                                                    Declared Value
                                                                </NavLink>
                                                            </li>
                                                            <li className="header-popper__item">
                                                                <NavLink onClick={this.handlePopperClose} to="/training" className="header-popper__link">
                                                                    Training
                                                                </NavLink>
                                                            </li>
                                                            <li className="header-popper__item">
                                                                <a href={this.rapidRewardsFAQUrl} target="_blank"
                                                                   rel="noopener noreferrer"
                                                                   className="external-link header-popper__link">Rapid Rewards<sup>®</sup> Cargo</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="header-popper__marketing-container">
                                                    <ContentPanel
                                                        skeleton={<Skeleton type="DESKTOP_NAVIGATION_PANEL" />}
                                                        errorTemplate={<Skeleton type="DESKTOP_NAVIGATION_PANEL_ERROR" />}
                                                        templateUrl="./content/navigation/page-components/text-block/learn-ad.html"
                                                    />
                                                </div>
                                                <button className="header-popper__close" onClick={this.handlePopperClose}>
                                                    <img src="./assets/icons/close.svg" alt="" />
                                                </button>
                                            </div>
                                        </Fade>
                                    </ClickAwayListener>
                                </Popper>

                                <Button id="about" className="header-toolbar-navigation__link" disableRipple={true} onClick={this.handleDesktopNavClick} color="inherit">
                                    About
                                </Button>
                                <Popper
                                    className="header-toolbar-popper"
                                    open={this.state.currentPopper === "about"}
                                    anchorEl={this.toolBarNavigationAnchorElement.current}
                                    onClose={this.handlePopperClose}
                                    placement={"bottom-end"}
                                >
                                    <ClickAwayListener onClickAway={this.handleDesktopNavClickAway}>
                                        <Fade timeout={300} in={this.state.currentPopper === "about"} id="menu-list">
                                            <div className="header-popper header-popper--about">
                                                <div className="header-popper__nav">
                                                    <div className="header-popper__title-container">
                                                        <img src="./assets/icons/tooltip.svg" alt="About" style={{ height: "36px", width: "36px" }} />
                                                        <NavLink to="/about/" onClick={this.handlePopperClose} className="header-popper__title">
                                                            About
                                                        </NavLink>
                                                    </div>
                                                    <div className="header-popper__lists-container">
                                                        <ul className="unstyled-list header-popper__list">
                                                            <li className="header-popper__item">
                                                                <NavLink onClick={this.handlePopperClose} to="/about/our-story" className="header-popper__link">
                                                                    Our Story
                                                                </NavLink>
                                                            </li>
                                                            <li className="header-popper__item">
                                                                <NavLink onClick={this.handlePopperClose} to="/about/awards" className="header-popper__link">
                                                                    Awards
                                                                </NavLink>
                                                            </li>
                                                            <li className="header-popper__item">
                                                                <NavLink onClick={this.handlePopperClose} to="/about/press-releases" className="header-popper__link">
                                                                    Press Releases
                                                                </NavLink>
                                                            </li>
                                                            <li className="header-popper__item">
                                                                <NavLink onClick={this.handlePopperClose} to="/about/news" className="header-popper__link">
                                                                    News
                                                                </NavLink>
                                                            </li>
                                                        </ul>
                                                        <ul className="unstyled-list header-popper__list">
                                                            <li className="header-popper__item">
                                                                <NavLink onClick={this.handlePopperClose} to="/about/customer-testimonials" className="header-popper__link">
                                                                    Testimonials
                                                                </NavLink>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="header-popper__marketing-container">
                                                    <ContentPanel
                                                        skeleton={<Skeleton type="DESKTOP_NAVIGATION_PANEL" />}
                                                        errorTemplate={<Skeleton type="DESKTOP_NAVIGATION_PANEL_ERROR" />}
                                                        templateUrl="./content/navigation/page-components/text-block/about-ad.html"
                                                    />
                                                </div>
                                                <button className="header-popper__close" onClick={this.handlePopperClose}>
                                                    <img src="./assets/icons/close.svg" alt="" />
                                                </button>
                                            </div>
                                        </Fade>
                                    </ClickAwayListener>
                                </Popper>

                                <Button id="search" className="header-toolbar-navigation__link" disableRipple={true} onClick={this.handleDesktopNavClick} color="inherit">
                                    <img className="header-popper--search__icon" src="./assets/icons/search.svg" alt="search icon" />
                                </Button>
                                <Popper
                                    className="header-toolbar-popper"
                                    open={this.state.currentPopper === "search"}
                                    anchorEl={this.toolBarNavigationAnchorElement.current}
                                    onClose={this.handlePopperClose}
                                    placement={"bottom-end"}
                                >
                                    <ClickAwayListener onClickAway={this.handleDesktopNavClickAway}>
                                        <Fade timeout={300} in={this.state.currentPopper === "search"} id="menu-list">
                                            <div className="header-popper header-popper--search">
                                                <div className="header-popper__nav">
                                                    <div className="header-popper__title-container">
                                                        <div className="header-popper-search__container">
                                                            <form className="header-popper-search__form">
                                                                <input className="header-popper-search__input" type="search" placeholder="Search..." onChange={e => this.handleSearch(e.target.value)} />
                                                                <NavLink onClick={this.handlePopperClose} to={`/search-results?search=${this.state.searchValue}`}>
                                                                    <button className="header-popper-search__button" type="submit">
                                                                        <img src="./assets/icons/search.svg" alt="Search"/>
                                                                    </button>
                                                                </NavLink>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>
                                                <button className="header-popper__close" onClick={this.handlePopperClose}>
                                                    <img src="./assets/icons/close.svg" alt="" />
                                                </button>
                                            </div>
                                        </Fade>
                                    </ClickAwayListener>
                                </Popper>
                            </div>
                        </nav>
                    </div>
                </Toolbar>
                <Navigation open={this.state.isMobileNavOpen} onClickAway={this.handleMobileNavClickAway} onLinkClick={this.handleMobileNavLinkClick} />
                <Overlay isShown={this.state.isOverlayShown} />
            </AppBar>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js